import React from "react";
import { get } from "lodash";
import { Container, Row, StyledIconGroup } from "./styled-components";
import Text from "../components/Text";
import { Props } from "../types";
import { useColorTokens } from "../../../../src";
import RaceDetail from "../components/RaceDetail";
import { buildQALabel, getSpecialPickTrackName } from "../utils";
import { CONTAINER, LEG, RACE_CELL, SPECIAL_PICK } from "../constants";
import TrackDetail from "../components/TrackDetail";

const SpecialPickLeg = ({ race, qaLabel = "", maxWidth, ...props }: Props) => {
  const color = useColorTokens("content.default");

  return (
    <Container
      data-qa-label={buildQALabel([
        qaLabel,
        RACE_CELL,
        SPECIAL_PICK,
        CONTAINER
      ])}
    >
      <RaceDetail
        video={race.video}
        mtp={race.mtp}
        postTime={race.postTime}
        status={race.status}
      />
      <TrackDetail
        raceNumber={get(
          race,
          "specialCardSourceRace.raceNumber",
          race.number ?? 0
        ).toString()}
        qaLabel={buildQALabel([qaLabel, RACE_CELL, SPECIAL_PICK])}
        trackName={getSpecialPickTrackName({
          name: get(
            race,
            "specialCardSourceRace.trackName",
            race.track.name ?? ""
          )
        })}
        maxWidth={maxWidth}
      />
      <Row>
        <Text
          qaLabel={buildQALabel([qaLabel, RACE_CELL, SPECIAL_PICK, LEG])}
          color={color}
          fontFamily="medium"
          fontWeight={700}
        >
          LEG {race.number.toString()}
        </Text>
        <StyledIconGroup
          {...props}
          qaLabel={buildQALabel([qaLabel, RACE_CELL, SPECIAL_PICK])}
        />
      </Row>
    </Container>
  );
};

export default SpecialPickLeg;
